import { useEffect, useState } from "react";
import { RowItemList } from "../../components/rowItemList";
import "./style.css";
import { getCategories } from "../../api/shop";
import { addIdKeyIfMissing } from "@delibrandev/utils/src/function.js";

export const Categories = () => {
  const [dataCategories, setDataCatagories] = useState({});
  console.log("Categories");
  console.log(dataCategories);

  const getQueryCategories = async () => {
    try {
      const payload = {};
      const response = await getCategories(payload);
      if (response && !response.error) {
        const data = {
          name: "Categorías",
          url: "categories",
          list: addIdKeyIfMissing(response.data.filter((f) => f.isActive === true)),
        };
        setDataCatagories(data);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
  };

  useEffect(() => {
    getQueryCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="homeContainer">{dataCategories && dataCategories.name && <RowItemList data={dataCategories} haveWrap={false} />}</div>;
};
